import { redirect } from "shared/lib/redirect"
import { useEvent } from "shared/lib/useEvent"

import { ErrorPageProps } from "../ErrorPage"

export function useErrorPageViewModel({ clearError }: ErrorPageProps) {
  const handleNavigation = useEvent(() => {
    clearError?.()
    redirect(window.location.origin)
  })

  return {
    navigate: handleNavigation
  }
}
